import useCountdown, { TimeType } from '@hooks/useCountdown'
import classNames from 'classnames'

const TimeUnit = ({ value, label, className }: any) => (
  <div className={classNames('flex flex-col', className)}>
    <p className="text-5xl font-700 text-center leading-none">
      {value.toString().padStart(2, '0')}
    </p>
    <p className="text-sm">{label}</p>
  </div>
)
const Countdown = ({ startTime }: { startTime: TimeType }) => {
  const [time] = useCountdown(startTime)

  return (
    <div style={{ width: 'fit-content' }} className="flex text-grey-800">
      <TimeUnit className="mr-3" label="DAYS" value={time.day} />
      <TimeUnit className="mr-3" label="HOURS" value={time.hour} />
      <TimeUnit className="mr-3" label="MINUTES" value={time.min} />
      <TimeUnit label="SECONDS" value={time.sec} />
    </div>
  )
}

export default Countdown
